export default __webpack_public_path__ + "static/media/hair-dark-autumn.2f2212fd.png";